module.exports = __webpack_public_path__ + "img/1534512145.694403a1.jpg";